export const countWords = (text = ''): number =>
	text.trim().split(/\s+/).filter(Boolean).length
